export const environment = {
  production: false,
  API_URL: 'https://testapi.prime-fuel.com/v1/client',
  CLIENT_URL: 'https://testclient.prime-fuel.com',
  SELF_URL: 'https://testpreview.prime-fuel.com'
};
